module.exports = __webpack_public_path__ + "img/daiyunying_banner.9712e4f5.png";